import ModalV2 from "../ModalV2";
import { BuildingOfficeIcon } from "@heroicons/react/24/outline";
import { ArrowRightIcon } from "lucide-react";
import { useState } from "react";
import useCompany from "../../hooks/useCompany";
import useModal from "../../hooks/useModal";

export default function CreateCompanyModal() {
  const { createCompany } = useCompany();
  const { close } = useModal('create-company');
  const [formData, setFormData] = useState({
    companyName: ""
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    createCompany({ name: formData.companyName })
    close();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (<ModalV2 name={'create-company'} className="!p-0 w-[600px]">
    <main className="w-full flex flex-col p-8">
      <div className="mb-8">
        <h2 className="text-xl font-semibold text-slate-900 ">
          Create New Company
        </h2>
        <p className="text-sm text-slate-500 mt-1">
          Please enter your company name to get started.
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-6 ">
        <div className="space-y-2">
          <label
            htmlFor="companyName"
            className="block text-sm font-medium text-slate-700"
          >
            Company Name
          </label>
          <div className="relative">
            <span className="absolute inset-y-0 left-0 pl-3 flex items-center text-slate-400 pointer-events-none">
              <BuildingOfficeIcon className="w-5 h-5" />
            </span>
            <input
              type="text"
              id="companyName"
              name="companyName"
              value={formData.companyName}
              onChange={handleChange}
              required
              placeholder="e.g. Acme Corp"
              className="block w-full pl-10 pr-3 py-3 bg-slate-50 border-none rounded-xl text-slate-900 placeholder-slate-400 focus:ring-2 focus:ring-blue-600 transition-all duration-200"
            />
          </div>
        </div>

        <div className="pt-8 mt-auto">
          <button
            type="submit"
            className="w-full bg-blue-600 text-white font-semibold py-4 rounded-xl shadow-lg shadow-blue-500/30 hover:bg-blue-700 active:scale-[0.98] transition-all duration-200 flex items-center justify-center gap-2"
          >
            <span>Create Company</span>
            <ArrowRightIcon className="w-4 h-4" />
          </button>
        </div>
      </form>
    </main>
  </ModalV2>)
}